"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAuthProvider = void 0;
exports.OAuthProvider = {
    google: "google",
};
